import { render, staticRenderFns } from "./search-result-type-document.vue?vue&type=template&id=d6f0af28&scoped=true&"
import script from "./search-result-type-document.vue?vue&type=script&lang=js&"
export * from "./search-result-type-document.vue?vue&type=script&lang=js&"
import style0 from "./search-result-type-document.vue?vue&type=style&index=0&id=d6f0af28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f0af28",
  null
  
)

export default component.exports